module.exports = __webpack_public_path__ + "img/home6.dc1888d6.png";